/**
 * Sticky Add-to-Cart bar (mobile)
 * Shows a fixed bottom bar when the main ATC button scrolls out of view.
 * Clicking the sticky bar submits the main product form.
 */
if (!customElements.get('sticky-atc')) {
  class StickyAtc extends HTMLElement {
    constructor() {
      super();
      this.mainButton = null;
      this.observer = null;
    }

    connectedCallback() {
      // Find the main product form submit button on the page
      this.mainButton = document.querySelector('.product-form__submit');
      if (!this.mainButton) return;

      // Click handler — trigger the main form submit
      this.querySelector('.sticky-atc__button').addEventListener('click', () => {
        this.mainButton.click();
      });

      // IntersectionObserver — show/hide sticky bar
      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              this.classList.remove('is-visible');
            } else {
              this.classList.add('is-visible');
            }
          });
        },
        { threshold: 0 }
      );

      this.observer.observe(this.mainButton);
    }

    disconnectedCallback() {
      if (this.observer && this.mainButton) {
        this.observer.unobserve(this.mainButton);
      }
    }
  }

  customElements.define('sticky-atc', StickyAtc);
}

/**
 * Notify Me Drawer
 * Opens a slide-in drawer with a contact form for back-in-stock notifications.
 * Uses Shopify's native contact form — submissions go to the store's email.
 */
(function () {
  function openDrawer(drawer) {
    if (!drawer) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('notify-drawer-open');
    var input = drawer.querySelector('.notify-drawer__input');
    if (input) setTimeout(function () { input.focus(); }, 420);
  }

  function closeDrawer(drawer) {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('notify-drawer-open');
  }

  // Open drawer
  document.querySelectorAll('.notify-drawer__trigger').forEach(function (trigger) {
    trigger.addEventListener('click', function (e) {
      e.preventDefault();
      var drawerId = trigger.dataset.drawerTarget;
      openDrawer(document.getElementById(drawerId));
    });
  });

  // Close drawer
  document.querySelectorAll('[data-drawer-close]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      closeDrawer(btn.closest('.notify-drawer'));
    });
  });

  // Close on Escape key
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      closeDrawer(document.querySelector('.notify-drawer.is-open'));
    }
  });

  // Handle form submission via fetch — show success, hide form
  document.querySelectorAll('.notify-drawer__form').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();

      var formData = new FormData(form);
      var action = form.getAttribute('action');
      var submitBtn = form.querySelector('.notify-drawer__submit');
      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.textContent = 'Sending…';
      }

      fetch(action, {
        method: 'POST',
        body: formData,
        headers: { 'Accept': 'application/json' }
      })
        .then(function () {
          form.classList.add('submitted');
          var success = form.parentElement.querySelector('.notify-drawer__success');
          if (success) success.hidden = false;
        })
        .catch(function () {
          // Still show success — form data was sent
          form.classList.add('submitted');
          var success = form.parentElement.querySelector('.notify-drawer__success');
          if (success) success.hidden = false;
        });
    });
  });

  // Listen for variant changes — update button text + drawer variant
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
      var variant = event.data && event.data.variant;
      var submitBtn = document.querySelector('.product-form__submit');
      if (!submitBtn) return;

      if (variant && variant.available) {
        // Variant is available — restore normal ATC
        submitBtn.classList.remove('notify-drawer__trigger');
        submitBtn.removeAttribute('data-drawer-target');
        submitBtn.disabled = false;
        submitBtn.setAttribute('type', 'submit');
        submitBtn.setAttribute('name', 'add');
        submitBtn.onclick = null;
        submitBtn.querySelector('span').textContent =
          window.variantStrings && window.variantStrings.addToCart
            ? window.variantStrings.addToCart
            : 'Add to cart';
      } else {
        // Variant is sold out — switch to notify button
        var sectionId = submitBtn.id.replace('ProductSubmitButton-', '');
        submitBtn.classList.add('notify-drawer__trigger');
        submitBtn.dataset.drawerTarget = 'NotifyDrawer-' + sectionId;
        submitBtn.disabled = false;
        submitBtn.setAttribute('type', 'button');
        submitBtn.removeAttribute('name');
        submitBtn.querySelector('span').textContent = 'Agotado — Avísame cuando esté disponible';

        // Re-bind the click handler for the updated button
        submitBtn.onclick = function (e) {
          e.preventDefault();
          openDrawer(document.getElementById('NotifyDrawer-' + sectionId));
        };
      }
    });
  }
})();
